import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

export default function CSlider({size="small", MAX = 100, MIN = 0, step = 10, label = "Name", onChange, defaultValue = 0 }) {
    const [val, setVal] = React.useState(defaultValue);
    const marks = [
        {
            value: MIN,
            label: '',
        },
        {
            value: MAX,
            label: '',
        },
    ];
    const handleChange = (_, newValue) => {
        setVal(newValue);
        if (onChange) onChange(newValue)
    };

    return (
        <Box sx={{ width: 1 }}>
            <Typography fontSize={11}>{label}</Typography>
            <Slider
                marks={marks}
                step={step}
                value={val}
                valueLabelDisplay="auto"
                min={MIN}
                max={MAX}
                onChange={handleChange}
                defaultValue={defaultValue}
                size={size}
            />
            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography
                    variant="body2"
                    onClick={() => setVal(MIN)}
                    sx={{ cursor: 'pointer' }}
                >
                    {MIN} min
                </Typography>
                <Typography
                    variant="body2"
                    onClick={() => setVal(MAX)}
                    sx={{ cursor: 'pointer' }}
                >
                    {MAX} max
                </Typography>
            </Box> */}
        </Box>
    );
}
